// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"fbf47a99","703":"31719fce","787":"70ccb53c"}[chunkId] + ".chunk.js";
};